import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import ProductCard from '../components/ProductCard';
import { allProducts } from '../data/mockData';
import { Search, SlidersHorizontal } from 'lucide-react';
import StoreMap from '../components/StoreMap';

const Furrmap = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('name');

  const categories = ['all', 'Dog Food', 'Cat Food', 'Treats'];

  const filteredProducts = allProducts
    .filter(product => {
      const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
      return matchesSearch && matchesCategory;
    })
    .sort((a, b) => {
      if (sortBy === 'price-low') return a.price - b.price;
      if (sortBy === 'price-high') return b.price - a.price;
      if (sortBy === 'rating') return b.rating - a.rating;
      return a.name.localeCompare(b.name);
    });

  return (
    <div className="py-5">
      <Container>
        {/* Page Header */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3">Our Partners</h1>
          <p className="text-muted">Browse our wide selection of premium pet stores</p>
        </div>

        {/* Filters */}
        <Row className="mb-4">
          <Col lg={12}>
            <div className="bg-light p-4 rounded-3 shadow-sm">
              <Row className="g-3 align-items-end">
                <Col md={4}>
                  <Form.Label className="fw-bold small mb-2">
                    <Search size={16} className="me-2" />
                    Search Store
                  </Form.Label>
                  <Form.Control 
                    type="text"
                    placeholder="Search for products..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label className="fw-bold small mb-2">
                    <SlidersHorizontal size={16} className="me-2" />
                    Category
                  </Form.Label>
                  <Form.Select 
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    {categories.map(cat => (
                      <option key={cat} value={cat}>
                        {cat === 'all' ? 'All Categories' : cat}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={4}>
                  <Form.Label className="fw-bold small mb-2">Sort By</Form.Label>
                  <Form.Select 
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value="name">Name (A-Z)</option>
                    <option value="price-low">Price (Low to High)</option>
                    <option value="price-high">Price (High to Low)</option>
                    <option value="rating">Rating</option>
                  </Form.Select>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        {/* Products Grid */}
        <Row>
          <Col lg={12}>
             <Row>
              <div style={{ height: '500px', borderRadius: '12px', overflow: 'hidden' }} className="shadow">
            <StoreMap />
          </div>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Furrmap;